<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 酒店区域/分类管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                  type="primary"
                  icon="el-icon-delete"
                  class="handle-del mr10"
                  @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-input class="handle-input mr10" clearable placeholder="关键字" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="initHotelArea" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="区域/位置名称" prop="Cname" sortable width="220"></el-table-column>
                <el-table-column label="区域/位置别名" prop="Csn" sortable></el-table-column>
                <el-table-column label="所属等级" prop="Clevel" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Clevel===1?'danger':(scope.row.Clevel===2?'success':'info')"
                        >{{scope.row.Clevel===1?'一级目录':(scope.row.Clevel===2?'二级目录':'三级目录')}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否末级" prop="CnodeFlg" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.CnodeFlg===1?'danger':'info'">{{scope.row.CnodeFlg===1?'是末级区位':'不是末级区位'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="排序编号" prop="CorderId" sortable></el-table-column>
                <el-table-column label="上级编号" prop="Cpid" sortable></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '屏蔽中', value: '0' }, { text: '正显示', value: '1' }]"
                                 align="center"
                                 label="景区状态"
                                 prop="Cstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Cstate===0?'danger':(scope.row.Cstate===1?'success':'info')"
                        >{{scope.row.Cstate===0?'屏蔽中':(scope.row.Cstate===1?'正显示':'正推荐')}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑酒店区域位置信息" width="40%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="区域名称">
                            <el-input clearable v-model="form.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="区域别名">
                            <el-input clearable v-model="form.Csn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="区域拼音">
                            <el-input clearable v-model="form.Chinese"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="排序编号">
                            <el-input clearable v-model="form.CorderId"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="所属区域">
                            <el-cascader  v-model="form.Cpid"
                                    :options="cityOptions"
                                    :props="{ checkStrictly: true }"
                                    clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="展示状态">
                            <el-select placeholder="请选择" v-model="form.Cstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in Opt.state"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="所属等级">
                            <el-select placeholder="请选择" v-model="form.Clevel">
                                <el-option :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            v-for="item in Opt.level"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="是否末级">
                            <el-select placeholder="请选择" v-model="form.CnodeFlg">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in Opt.node"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {

                value: [],
                cityOptions: [{
                    value: '叠彩区',
                    label: '叠彩区',
                    children: [{
                        value: '桂林北站',
                        label: '桂林北站'
                    }, {
                        value: '叠彩万达',
                        label: '叠彩万达'
                    }]
                }, {
                    value: '象山区',
                    label: '象山区',
                    children: [{
                        value: 'basic',
                        label: '象鼻山'
                    }, {
                        value: 'form',
                        label: '桂林火车站'
                    }, {
                        value: 'data',
                        label: '南溪山'
                    }]
                }, {
                    value: 'ziyuan',
                    label: '龙脊梯田景区',
                    children: [{
                        value: 'axure',
                        label: '平安寨'
                    }, {
                        value: '东二环',
                        label: '金坑大寨'
                    }, {
                        value: 'jiaohu',
                        label: '古壮寨'
                    }]
                }],
                Opt:{
                    state: [{
                        value: 0,
                        label: '屏蔽中'
                    }, {
                        value: 1,
                        label: '正常展示'
                    }],
                    level: [{
                        value: 1,
                        label: '一级目录'
                    }, {
                        value: 2,
                        label: '二级目录'
                    }, {
                        value: 3,
                        label: '三级目录'
                    }],
                    node: [{
                        value: 0,
                        label: '不是末级'
                    }, {
                        value: 1,
                        label: '是末级'
                    }]
                },

                sceOpt: {
                    city: [],
                    free: {}
                },
                query: {
                    pageIndex: 1,
                    pageSize: 10,
                    did: 17
                },
                search: {
                    keyword: '',
                    menu: '',
                    did:17
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            // this.reload();
            this.initHotelArea();
        },
        methods: {

            handleChange(value) {
                console.log(value);
            },

            async initHotelArea() {
                const { data: res } = await this.$http.post('admin/hotels/initHotelArea', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点分类数据失败，请联系管理员!');
                }
                this.sceOpt.city = res.city;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;
                this.cityOptions=res.cityOpt;
                this.search.keyword = '';
                this.search.menu = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【景点区域数据】加载成功!');
            },
            // 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/hotels/searchHotelArea', {
                    query: this.search
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }

                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },

            // 新增操作
            handleAdd() {
                this.addVisible = true;
            },

            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },

            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/hotels/updatHotelArea', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.initHotelArea();
            },
            //标签筛选
            filterTag(value, row) {
                console.log('is runing' + value);
                return row.Sstate == value;
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
